import _once from "lodash/once";
import React from 'react';
import { LinkButton } from '../button/Button';
import { sendEvent } from '../../../../../../client/analytics/dataLayerService';
import { DATALAYER_EVENT } from '../../../../../../client/analytics/dataLayerConstants';
import { Platform, getPlatform } from '../../../../../util/getPlatform';
import { getUtmQueryParam } from '../../../../../util/utmHelper';
import AppStoreBadge from './AppStoreBadge.svg';
import GooglePlayBadge from './GooglePlayBadge.svg';
import './AppStoreButton.scss';
var GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.milanote.milanoteApp';
var APP_STORE_URL = 'https://itunes.apple.com/us/app/milanote/id1433852790?ls=1&mt=8';
var sendAppStoreLinkClickEvent = _once(function () {
  return sendEvent(DATALAYER_EVENT.APP_STORE_LINK_CLICK);
});
var AppleAppStoreButton = function AppleAppStoreButton() {
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: sendAppStoreLinkClickEvent,
    cta: true,
    href: APP_STORE_URL,
    className: "AppStoreButton"
  }, /*#__PURE__*/React.createElement("img", {
    src: AppStoreBadge,
    alt: "Download on Apple App Store"
  }));
};
var GooglePlayButton = function GooglePlayButton() {
  var utmParam = getUtmQueryParam();
  var url = utmParam ? "".concat(GOOGLE_PLAY_URL, "&referrer=").concat(utmParam) : GOOGLE_PLAY_URL;
  return /*#__PURE__*/React.createElement(LinkButton, {
    onClick: sendAppStoreLinkClickEvent,
    cta: true,
    href: url,
    className: "AppStoreButton"
  }, /*#__PURE__*/React.createElement("img", {
    src: GooglePlayBadge,
    alt: "Get it on Google Play"
  }));
};
export var AppStoreButton = function AppStoreButton() {
  var platform = getPlatform();
  switch (platform) {
    case Platform.ANDROID:
      return /*#__PURE__*/React.createElement(GooglePlayButton, null);
    case Platform.IOS:
      return /*#__PURE__*/React.createElement(AppleAppStoreButton, null);
    default:
      return /*#__PURE__*/React.createElement(LinkButton, {
        cta: true,
        href: "#signup-form"
      }, "Sign up for free");
  }
};